var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classCustom},[_vm._t("header"),_vm._v(" "),_vm._t("view",function(){return [_vm._t("subHeaderExtend"),_vm._v(" "),_vm._t("subHeader"),_vm._v(" "),_vm._t("body"),_vm._v(" "),_vm._t("detail")]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d9ba9c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/list.vue
// module id = yYLt
// module chunks = 89